import {AutogenLayoutRateIndexRateOptionsPanel} from "./autogen/AutogenLayoutRateIndexRateOptionsPanel";
import {ChangeEvent} from "@mcleod/components";

export class RateIndexRateOptionsPanel extends AutogenLayoutRateIndexRateOptionsPanel {

    switchUseMarketRateFuelSurchargeOnChange(event: ChangeEvent){
        this.textboxCustomerId.visible = event.newValue === false;
        this.textboxCustomerId.required = event.newValue === false;
    }
}
